/* GENERAL */
function sha256(data) {
    let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a,
        h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19,
        tsz = 0, bp = 0;
    const k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
               0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
               0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
               0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
               0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
               0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
               0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
               0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2],
          rrot = (x, n) => (x >>> n) | (x << (32-n)),
          w = new Uint32Array(64),
          buf = new Uint8Array(64),
          process = () => {
              for (let j=0,r=0; j<16; j++,r+=4) {
                  w[j] = (buf[r]<<24) | (buf[r+1]<<16) | (buf[r+2]<<8) | buf[r+3];
              }
              for (let j=16; j<64; j++) {
                  let s0 = rrot(w[j-15], 7) ^ rrot(w[j-15], 18) ^ (w[j-15] >>> 3);
                  let s1 = rrot(w[j-2], 17) ^ rrot(w[j-2], 19) ^ (w[j-2] >>> 10);
                  w[j] = (w[j-16] + s0 + w[j-7] + s1) | 0;
              }
              let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7;
              for (let j=0; j<64; j++) {
                  let S1 = rrot(e, 6) ^ rrot(e, 11) ^ rrot(e, 25),
                      ch = (e & f) ^ ((~e) & g),
                      t1 = (h + S1 + ch + k[j] + w[j]) | 0,
                      S0 = rrot(a, 2) ^ rrot(a, 13) ^ rrot(a, 22),
                      maj = (a & b) ^ (a & c) ^ (b & c),
                      t2 = (S0 + maj) | 0;
                  h = g; g = f; f = e; e = (d + t1)|0; d = c; c = b; b = a; a = (t1 + t2)|0;
              }
              h0 = (h0 + a)|0; h1 = (h1 + b)|0; h2 = (h2 + c)|0; h3 = (h3 + d)|0;
              h4 = (h4 + e)|0; h5 = (h5 + f)|0; h6 = (h6 + g)|0; h7 = (h7 + h)|0;
              bp = 0;
          },
          add = data => {
              if (typeof data === "string") {
                  data = typeof TextEncoder === "undefined" ? Buffer.from(data) : (new TextEncoder).encode(data);
              }
              for (let i=0; i<data.length; i++) {
                  buf[bp++] = data[i];
                  if (bp === 64) process();
              }
              tsz += data.length;
          },
          digest = () => {
              buf[bp++] = 0x80; if (bp == 64) process();
              if (bp + 8 > 64) {
                  while (bp < 64) buf[bp++] = 0x00;
                  process();
              }
              while (bp < 58) buf[bp++] = 0x00;
              // Max number of bytes is 35,184,372,088,831
              let L = tsz * 8;
              buf[bp++] = (L / 1099511627776.) & 255;
              buf[bp++] = (L / 4294967296.) & 255;
              buf[bp++] = L >>> 24;
              buf[bp++] = (L >>> 16) & 255;
              buf[bp++] = (L >>> 8) & 255;
              buf[bp++] = L & 255;
              process();
              let reply = new Uint8Array(32);
              reply[ 0] = h0 >>> 24; reply[ 1] = (h0 >>> 16) & 255; reply[ 2] = (h0 >>> 8) & 255; reply[ 3] = h0 & 255;
              reply[ 4] = h1 >>> 24; reply[ 5] = (h1 >>> 16) & 255; reply[ 6] = (h1 >>> 8) & 255; reply[ 7] = h1 & 255;
              reply[ 8] = h2 >>> 24; reply[ 9] = (h2 >>> 16) & 255; reply[10] = (h2 >>> 8) & 255; reply[11] = h2 & 255;
              reply[12] = h3 >>> 24; reply[13] = (h3 >>> 16) & 255; reply[14] = (h3 >>> 8) & 255; reply[15] = h3 & 255;
              reply[16] = h4 >>> 24; reply[17] = (h4 >>> 16) & 255; reply[18] = (h4 >>> 8) & 255; reply[19] = h4 & 255;
              reply[20] = h5 >>> 24; reply[21] = (h5 >>> 16) & 255; reply[22] = (h5 >>> 8) & 255; reply[23] = h5 & 255;
              reply[24] = h6 >>> 24; reply[25] = (h6 >>> 16) & 255; reply[26] = (h6 >>> 8) & 255; reply[27] = h6 & 255;
              reply[28] = h7 >>> 24; reply[29] = (h7 >>> 16) & 255; reply[30] = (h7 >>> 8) & 255; reply[31] = h7 & 255;
              reply.hex = () => {
                  let res = "";
                  reply.forEach(x => res += ("0" + x.toString(16)).slice(-2));
                  return res;
              };
              return reply;
          };
    if (data === undefined) return {add, digest};
    add(data);
    return digest();
}

async function getUrlContent(url) {
  try {
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
    }

    const content = await response.text();
    return content;
  } catch (error) {
    console.error('Error fetching URL content:', error);
    throw error;
  }
}

/* window.theme */
window.theme = window.theme || {};

theme.Currency = (function() {
  const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit
  };
})();

if (typeof Dtails === "undefined") {
  var Dtails = {};
}

/* Dtails FUNCTIONS */
function getBundleStatus (bundleData) {
  var bundleIsInStock = false;
  var bundleIsPreOrder = false;
  var bundleIsPreOrderHasAvailableDate = false;
  var bundleIsSoldOut = false;
  var bundleIsSoldOutHasAvailableDate = false;
  
  var bundleBackInStockDate = '';

  var bundleInStockText = '';
  var bundlePreOderText = '';
  var bundlePrderOrderHasAvailableDateText = '';
  var bundleSoldOutText = '';
  var bundleSoldOutHasAvailableDate = '';

  if (bundleData && bundleData.length) {
    var isAllChildsPrepacked = true;
    bundleData.map(function (bundleItem) {
      if (bundleItem.isPrepacked == false) {
        isAllChildsPrepacked = false;
      }
    });

    if (!isAllChildsPrepacked && bundleData[0].products !== "undefined") {
      const bundleProducts = bundleData[0].products;
      
      bundleProducts.map(function (bundleProduct) {
        if (bundleProduct.stockTextType != 'instock') {
          bundleIsPreOrder = true;
          bundlePreOderText = bundleProduct.stockStatusText;

          if (bundleProduct.backinstockDate) {
            bundleIsPreOrderHasAvailableDate = true;

            if (bundleBackInStockDate == '') {
              bundleBackInStockDate = bundleProduct.backInstockDate;
              bundlePrderOrderHasAvailableDateText = bundleProduct.stockStatusText;
            } else {
              let bundleBackInStockDateTime = new Date(bundleBackInStockDate);
              let backInstockDateTime = new Date(bundleProduct.backInstockDate);
              if (backInstockDateTime.getTime() > bundleBackInStockDateTime.getTime()) {
                bundleBackInStockDate = bundleProduct.backInstockDate;
                bundlePrderOrderHasAvailableDateText = bundleProduct.stockStatusText;
              }
            }
          }
        } else {
          bundleIsInStock = true;
          bundleInStockText = bundleProduct.stockStatusText;
        }

        if (bundleProduct.stockTextType == 'soldout') {
          bundleIsSoldOut = true;
          bundleSoldOutText = bundleProduct.stockStatusText;
          
          if (bundleProduct.backInstockDate) {
            bundleIsSoldOutHasAvailableDate = true;
            bundleSoldOutHasAvailableDate = bundleProduct.stockStatusText;
          }
        }
      });
    }
  }

  var bundleStockTextType = ''
  if (bundleIsInStock) {
    bundleStockTextType = 'instock';
  }
  if (bundleIsPreOrder) {
    bundleStockTextType = 'preorder_with_unknown_date';
  }
  if (bundleIsPreOrderHasAvailableDate) {
    bundleStockTextType = 'preorder_with_available_date';
  }
  if (bundleIsSoldOut) {
    bundleStockTextType = 'soldout';
  }
  if (bundleIsSoldOutHasAvailableDate) {
    bundleStockTextType = 'soldout_with_available_date';
  }

  var bundleStockStatusText = '';
  if (bundleInStockText) {
    bundleStockStatusText = bundleInStockText;
  }
  if (bundlePreOderText) {
    bundleStockStatusText = bundlePreOderText;
  }
  if (bundlePrderOrderHasAvailableDateText) {
    bundleStockStatusText = bundlePrderOrderHasAvailableDateText;
  }
  if (bundleSoldOutText) {
    bundleStockStatusText = bundleSoldOutText;
  }
  if (bundleSoldOutHasAvailableDate) {
    bundleStockStatusText = bundleSoldOutHasAvailableDate;
  }
  
  var bundleStatus = [];
  bundleStatus.bundleStockTextType = bundleStockTextType;
  bundleStatus.bundleStockStatusText = bundleStockStatusText;
  return bundleStatus;
}

function updateCrosssellItemsModal(modalId, crosssellData) {
  const modalElement = document.querySelector('#' + modalId);
  if (modalElement) {
    const pdpCrosssellProductsElement = modalElement.querySelector('.pdo-crosssell-products');
    if (pdpCrosssellProductsElement) {
      var crosssellProductIds = [];

      const crosssellProductsItemsElement = pdpCrosssellProductsElement.querySelector('.items');
      if (crosssellProductsItemsElement) {
        // set the template
        var crosssellCustomPriceTemplate = '';
        const crosssellCustomPriceElement = crosssellProductsItemsElement.querySelector('.custom-price');
        if (crosssellCustomPriceElement) {
          crosssellCustomPriceTemplate = crosssellCustomPriceElement.innerHTML;
          crosssellCustomPriceElement.innerHTML = '{{ customPrice }}';
        }

        var crosssellVariantSelectTemplate = '';
        var soldOutText = '';
        const crosssellVariantSelectElement = crosssellProductsItemsElement.querySelector('.variant-picker select');
        if (crosssellVariantSelectElement) {
          soldOutText = crosssellVariantSelectElement.dataset.soldOutText;
          crosssellVariantSelectTemplate = crosssellVariantSelectElement.innerHTML;
          crosssellVariantSelectElement.innerHTML = '{{ variantOption }}';
        }

        var crosssellStockStatusTemplate = '';
        const crosssellStockStatusElement = crosssellProductsItemsElement.querySelector('.stock-status');
        if (crosssellStockStatusElement) {
          crosssellStockStatusTemplate = crosssellStockStatusElement.innerHTML;
          crosssellStockStatusElement.innerHTML = '{{ stockStatus }}';
        }

        var addToCartText = '';
        var soldOutText = '';
        var preOrderText = '';
        var crosssellAtcBtnTemplate = '';
        const crosssellAtcBtnElement = crosssellProductsItemsElement.querySelector('.button-holder');
        if (crosssellAtcBtnElement) {
          addToCartText = crosssellAtcBtnElement.dataset.addToCartText;
          soldOutText = crosssellAtcBtnElement.dataset.soldOutText;
          preOrderText = crosssellAtcBtnElement.dataset.preOrderText;
          crosssellAtcBtnTemplate = crosssellAtcBtnElement.innerHTML;
          crosssellAtcBtnElement.innerHTML = '{{ buttonHolder }}';
        }

        const crosssellProductTemplate = crosssellProductsItemsElement.innerHTML;
        crosssellProductsItemsElement.innerHTML = "";

        // update data
        if (crosssellData) {
          crosssellData.map(function (crosssellItem) {
            const crosssellProducts = crosssellItem.products;
            crosssellProducts.map(function (crosssellProduct) {
              if (crosssellProduct.available) {
                // ignore existed upsell products
                if (!crosssellProductIds.includes(crosssellProduct.id)) {
                  var crosssellProductHTML = crosssellProductTemplate;
                  const imgUrl = '<img src="' + crosssellProduct.imgUrl + '" alt="' + crosssellProduct.title + '" />';
            
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ id }}/g, crosssellProduct.id);
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ handle }}/g, crosssellProduct.handle);
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ imgUrl }}/g, imgUrl);
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ selectedVariantId }}/g, crosssellProduct.selectedVariantId);
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ selectedVariantSku }}/g, crosssellProduct.selectedVariantSku);
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ title }}/g, crosssellProduct.titleTag.replace('[title]', crosssellProduct.title));
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ quantity }}/g, crosssellProduct.quantity);
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ savePercentage }}/g, crosssellItem.discountPercent);

                  if (crosssellProduct.bundleData) {
                    crosssellProductHTML = crosssellProductHTML.replace(/{{ bundleData }}/g, JSON.stringify(crosssellProduct.bundleData));
                  } else {
                    crosssellProductHTML = crosssellProductHTML.replace(/{{ bundleData }}/g, '');
                  }

                  // bundle stock status
                  const bundleStatus = getBundleStatus(crosssellProduct.bundleData);
                  const bundleStockTextType = bundleStatus.bundleStockTextType;
                  const bundleStockStatusText = bundleStatus.bundleStockStatusText;

                  // update variant data
                  var hasInstockVariant = false;

                  var crosssellCustomPriceHTML = '';
                  var crosssellVariantOptionHTML = '';
                  var crosssellStockStatusHTML = '';
                  var crosssellAtcBtnHTML = '';
                  crosssellProduct.variants.map(function (variant) {
                    // update variant price
                    crosssellCustomPriceHTML += '<div data-crosssell-variant-metafield="' + variant.id + '" class="' + (variant.id == crosssellProduct.selectedVariantId ? "" : "hidden") + '">';
                    crosssellCustomPriceHTML += crosssellCustomPriceTemplate;
                    crosssellCustomPriceHTML += '</div>';

                    crosssellCustomPriceHTML = crosssellCustomPriceHTML.replace(/{{ price }}/g, theme.Currency.formatMoney(variant.discountedPrice * 100, theme.moneyFormat));
                    crosssellCustomPriceHTML = crosssellCustomPriceHTML.replace(/{{ compareAtPrice }}/g, theme.Currency.formatMoney(variant.compareAtPrice * 100, theme.moneyFormat));
                    crosssellCustomPriceHTML = crosssellCustomPriceHTML.replace(/{{ savePercentage }}/g, crosssellItem.discountPercent);

                    if (crosssellItem.discountPercent <= 0) {
                      crosssellCustomPriceHTML = crosssellCustomPriceHTML.replace(/{{ customSaveClass }}/g, 'hidden');
                    } else {
                      crosssellCustomPriceHTML = crosssellCustomPriceHTML.replace(/{{ customSaveClass }}/g, '');
                    }

                    // update variant picker
                    crosssellVariantOptionHTML += crosssellVariantSelectTemplate;

                    crosssellVariantOptionHTML = crosssellVariantOptionHTML.replace(/{{ variantSku }}/g, variant.sku);
                    crosssellVariantOptionHTML = crosssellVariantOptionHTML.replace(/{{ variantId }}/g, variant.id);
                    if (variant.id == crosssellProduct.selectedVariantId) {
                      crosssellVariantOptionHTML = crosssellVariantOptionHTML.replace('selected-or-not', 'selected');
                    }
                    if (!variant.available) {
                      crosssellVariantOptionHTML = crosssellVariantOptionHTML.replace('disabled-or-not', 'disabled');
                      crosssellVariantOptionHTML = crosssellVariantOptionHTML.replace(/{{ variantTitle }}/g, variant.title + ' - ' + soldOutText);
                    } else {
                      crosssellVariantOptionHTML = crosssellVariantOptionHTML.replace(/{{ variantTitle }}/g, variant.title);
                    }

                    // update variant stock status
                    crosssellStockStatusHTML += '<div data-crosssell-variant-metafield="' + variant.id + '" class="' + (variant.id == crosssellProduct.selectedVariantId ? "" : "hidden") + '">';
                    crosssellStockStatusHTML += crosssellStockStatusTemplate;
                    crosssellStockStatusHTML += '</div>';

                    var variantStockTextType = variant.stockTextType;
                    if (bundleStockTextType) {
                      variantStockTextType = bundleStockTextType;
                    }
                    crosssellStockStatusHTML = crosssellStockStatusHTML.replace(/{{ stockTextType }}/g, variantStockTextType);
                    
                    if (bundleStockStatusText) {
                      crosssellStockStatusHTML = crosssellStockStatusHTML.replace(/{{ stockStatusText }}/g, bundleStockStatusText);
                    } else {
                      crosssellStockStatusHTML = crosssellStockStatusHTML.replace(/{{ stockStatusText }}/g, variant.stockStatusText);
                    }

                    // update variant add to cart button
                    crosssellAtcBtnHTML += '<div data-crosssell-variant-metafield="' + variant.id + '" class="' + (variant.id == crosssellProduct.selectedVariantId ? "" : "hidden") + '">';
                    crosssellAtcBtnHTML += crosssellAtcBtnTemplate;
                    crosssellAtcBtnHTML += '</div>';

                    var buttonText = '';
                    var preOrderBtnClass = '';
                    var disableButton = false;
                    if (variantStockTextType == 'instock') {
                      hasInstockVariant = true;
                      buttonText = addToCartText;
                    }
                    if (variantStockTextType == 'preorder_remote_stock' || variantStockTextType == 'preorder_with_available_date' || variantStockTextType == 'preorder_with_passed_date' || variantStockTextType == 'preorder_with_unknown_date') {
                      hasInstockVariant = true;
                      buttonText = preOrderText;
                      preOrderBtnClass = 'btn-pre-order';
                    }
                    if (variantStockTextType == 'soldout' || variantStockTextType == 'soldout_with_available_date') {
                      buttonText = soldOutText;
                      disableButton = true;
                    }

                    crosssellAtcBtnHTML = crosssellAtcBtnHTML.replace(/{{ buttonText }}/g, buttonText);
                    crosssellAtcBtnHTML = crosssellAtcBtnHTML.replace(/{{ preOrderBtnClass }}/g, preOrderBtnClass);
                    if (disableButton) {
                      crosssellAtcBtnHTML = crosssellAtcBtnHTML.replace('disabled-or-not', 'disabled');
                    }
                  });

                  crosssellProductHTML = crosssellProductHTML.replace(/{{ customPrice }}/g, crosssellCustomPriceHTML);

                  if (crosssellProduct.variants.length > 1) {
                    crosssellProductHTML = crosssellProductHTML.replace(/{{ variantOption }}/g, crosssellVariantOptionHTML);
                  } else {
                    const crosssellSelectedVariantInputHTML = '<input type="hidden" name="crosssell_variant_id" value="' + crosssellProduct.selectedVariantId + '" />';
                    crosssellProductHTML = crosssellProductHTML.replace(/{{ variantOption }}/g, crosssellSelectedVariantInputHTML);
                  }

                  crosssellProductHTML = crosssellProductHTML.replace(/{{ stockStatus }}/g, crosssellStockStatusHTML);
                  crosssellProductHTML = crosssellProductHTML.replace(/{{ buttonHolder }}/g, crosssellAtcBtnHTML);

                  if (hasInstockVariant) {
                    crosssellProductIds.push(crosssellProduct.id);
                    crosssellProductsItemsElement.innerHTML = crosssellProductsItemsElement.innerHTML + crosssellProductHTML;
                  }
                }
              }
            });
          });
        }

        // onChange variant picker
        const updatedCrosssellProductsItemElements = crosssellProductsItemsElement.querySelectorAll('.item');
        if (updatedCrosssellProductsItemElements.length) {
          updatedCrosssellProductsItemElements.forEach(updatedCrosssellProductsItemElement => {
            const updatedCrosssellVariantSelectElement = updatedCrosssellProductsItemElement.querySelector('.variant-picker select');
            if (updatedCrosssellVariantSelectElement) {
              if (updatedCrosssellVariantSelectElement.innerHTML) {
                const updatedCrosssellAtcElement = updatedCrosssellProductsItemElement.querySelector('.atc');
                if (updatedCrosssellAtcElement) {
                  const selectedVariantSkuInput = updatedCrosssellAtcElement.querySelector('input[name="selected_variant_sku"]');

                  updatedCrosssellVariantSelectElement.addEventListener('change', function() {
                    const selectedVariantId = this.value;
                    const selectedVariantSku = this.options[this.selectedIndex].dataset.sku;

                    if (selectedVariantSkuInput) {
                      selectedVariantSkuInput.value = selectedVariantSku;
                    }

                    updatedCrosssellProductsItemElement.querySelectorAll('[data-crosssell-variant-metafield]').forEach((elem) => {
                      elem.classList.toggle('hidden', elem.dataset.crosssellVariantMetafield !== selectedVariantId.toString());
                    });
                  });
                }
              } else {
                updatedCrosssellVariantSelectElement.remove();
              }
            }
          });
        }
      }

      if (crosssellProductIds.length) {
        pdpCrosssellProductsElement.classList.remove('hidden');
      }
    }
  }
}

function initQuantitySelector() {
  // Select all elements with the class 'quantity-selector'
  const quantitySelectors = document.querySelectorAll('.quantity-selector');

  // Loop through each quantity selector to add functionality
  quantitySelectors.forEach(selector => {
      // Get references to the HTML elements within the current selector
      const decrementBtn = selector.querySelector('.decrement-btn');
      const incrementBtn = selector.querySelector('.increment-btn');
      const quantityInput = selector.querySelector('.quantity-input');

      /**
       * Event listener for the decrement button.
       * Decreases the quantity, but not below the minimum value (1).
       */
      decrementBtn.addEventListener('click', () => {
          // Get the current value and convert it to a number
          let currentValue = parseInt(quantityInput.value);

          // Check if the current value is greater than the minimum
          if (currentValue > parseInt(quantityInput.min)) {
              quantityInput.value = currentValue - 1;
          }
      });

      /**
       * Event listener for the increment button.
       * Increases the quantity by one.
       */
      incrementBtn.addEventListener('click', () => {
          // Get the current value and convert it to a number
          let currentValue = parseInt(quantityInput.value);
          
          // Increase the value by one
          quantityInput.value = currentValue + 1;
      });

      quantityInput.addEventListener('input', function(event) {
        if (this.value === '') {
          this.value = '1';
        }
      });
  });
}

/* Dtails CLASSES */
Dtails.ProductUpdater = {
  init: function () {
    this.updateProduct();
  },
  updateProduct() {
    const pdpProductContentElement = document.getElementById('pdp-product-content');
    const pdpProductDetailsElement = document.getElementById('pdp-product-details');

    const productId = pdpProductContentElement.dataset.productId;
    const selectedVariantId = pdpProductContentElement.dataset.selectedVariantId;
    
    if (productId) {
      const pdoURL = window.routes.searchUrl + '?view=product-data-object&type=product&q=id:' + productId;
      getUrlContent(pdoURL)
        .then(content => {
          const response = JSON.parse(content);
          if (response[0][productId][0] !== "undefined") {
            const productData = response[0][productId][0];
            const variants = productData.variants;
            const bundleData = productData.bundleData;
            
            /* PRICE */
            if (pdpProductContentElement) {
              const pdpPriceElement = pdpProductContentElement.querySelector('.pdo-custom-price');
              if (pdpPriceElement) {
                // set the template
                const customPriceTemplate = pdpPriceElement.innerHTML;
                pdpPriceElement.innerHTML = "";

                variants.map(function (variant) {
                  // prepare the template
                  var priceHTML = '<div data-variant-metafield="' + variant.id + '" class="' + (variant.id == selectedVariantId ? "" : "hidden") + '">';
                  priceHTML += customPriceTemplate;
                  priceHTML += '</div>';

                  // update the data
                  priceHTML = priceHTML.replace(/{{ price }}/g, theme.Currency.formatMoney(variant.price * 100, theme.moneyFormat));
                  priceHTML = priceHTML.replace(/{{ compareAtPrice }}/g, theme.Currency.formatMoney(variant.compareAtPrice * 100, theme.moneyFormat));
                  priceHTML = priceHTML.replace(/{{ savePercentage }}/g, variant.savePercentage);
                  priceHTML = priceHTML.replace(/{{ saveUpToPercentage }}/g, productData.saveUpToPercentage);

                  // show/hide the element
                  if (variant.savePercentage <= 0) {
                    priceHTML = priceHTML.replace(/{{ customSaveClass }}/g, 'hidden');
                  } else {
                    priceHTML = priceHTML.replace(/{{ customSaveClass }}/g, '');
                  }
                  if (productData.saveUpToPercentage <= 0) {
                    priceHTML = priceHTML.replace(/{{ saveUpToPercentageClass }}/g, 'hidden');
                  } else {
                    priceHTML = priceHTML.replace(/{{ saveUpToPercentageClass }}/g, '');
                  }

                  pdpPriceElement.innerHTML = pdpPriceElement.innerHTML + priceHTML;

                  // hide the default price
                  const pdpDefaultPriceElement = pdpProductContentElement.querySelector('.product-info__price');
                  if (pdpDefaultPriceElement) {
                    pdpDefaultPriceElement.classList.add('hidden');
                  }
                });

                pdpPriceElement.classList.remove('hidden');
              }

              // apply content to other selectors
              const pdpPriceElements = pdpProductContentElement.querySelectorAll('.pdo-custom-price');
              if (pdpPriceElements.length >= 2) {
                const pdpPriceElementHTML = pdpPriceElement.innerHTML;

                pdpPriceElements.forEach(pdpPriceElementItem => {
                  if (pdpPriceElementItem.innerHTML == "") {
                    pdpPriceElementItem.innerHTML = pdpPriceElementHTML;
                    pdpPriceElementItem.classList.remove('hidden');
                  }
                });
              }
            }

            /* STOCK STATUS */
            if (pdpProductContentElement) {
              const pdpStockStatusElement = pdpProductContentElement.querySelector('.pdo-stock-status');
              if (pdpStockStatusElement) {
                var stockStatusBuyNowText = pdpStockStatusElement.dataset.buyNowText;

                // set the template
                const stockStatusTemplate = pdpStockStatusElement.innerHTML;
                pdpStockStatusElement.innerHTML = "";

                // set data if it's a bundle product
                const bundleStatus = getBundleStatus(bundleData);
                const bundleStockTextType = bundleStatus.bundleStockTextType;
                const bundleStockStatusText = bundleStatus.bundleStockStatusText;

                // add to cart from product data object
                const pdpAtcBtnElement = pdpProductContentElement.querySelector('.pdo-atc-btn');
                var atcBtnTemplate = '';
                var addToCartText = '';
                var buyNowText = '';
                var soldOutText = '';
                var preOrderText = '';
                if (pdpAtcBtnElement) {
                  // set the template
                  atcBtnTemplate = pdpAtcBtnElement.innerHTML;
                  addToCartText = pdpAtcBtnElement.dataset.addToCartText;
                  buyNowText = pdpAtcBtnElement.dataset.buyNowText;
                  soldOutText = pdpAtcBtnElement.dataset.soldOutText;
                  preOrderText = pdpAtcBtnElement.dataset.preOrderText;
                  pdpAtcBtnElement.innerHTML = "";
                }

                variants.map(function (variant) {
                  // prepare the template
                  var stockStatusHTML = '<div data-variant-metafield="' + variant.id + '" class="' + (variant.id == selectedVariantId ? "" : "hidden") + '">';
                  stockStatusHTML += stockStatusTemplate;
                  stockStatusHTML += '</div>';

                  // update the data
                  var variantStockTextType = variant.stockTextType;
                  if (bundleStockTextType) {
                    variantStockTextType = bundleStockTextType;
                  }
                  stockStatusHTML = stockStatusHTML.replace(/{{ stockTextType }}/g, variantStockTextType);
                  
                  var variantStockStatusText = variant.stockStatusText;
                  if (variantStockTextType == 'instock' && stockStatusBuyNowText != '') {
                    variantStockStatusText = stockStatusBuyNowText;
                  } else {
                    if (bundleStockStatusText) {
                      variantStockStatusText = bundleStockStatusText;
                    }
                  }
                  stockStatusHTML = stockStatusHTML.replace(/{{ stockStatusText }}/g, variantStockStatusText);

                  pdpStockStatusElement.innerHTML = pdpStockStatusElement.innerHTML + stockStatusHTML;

                  // add to cart from product data object
                  if (pdpAtcBtnElement) {
                    var buttonText = '';
                    var buttonBuyNowText = '';
                    var preOrderBtnClass = '';
                    var disableButton = false;
                    if (variantStockTextType == 'instock') {
                      buttonText = addToCartText;
                      buttonBuyNowText = buyNowText;
                    }
                    if (variantStockTextType == 'preorder_remote_stock' || variantStockTextType == 'preorder_with_available_date' || variantStockTextType == 'preorder_with_passed_date' || variantStockTextType == 'preorder_with_unknown_date') {
                      buttonText = preOrderText;
                      buttonBuyNowText = preOrderText;
                      preOrderBtnClass = 'btn-pre-order';
                    }
                    if (variantStockTextType == 'soldout' || variantStockTextType == 'soldout_with_available_date') {
                      buttonText = soldOutText;
                      buttonBuyNowText = soldOutText;
                      disableButton = true;
                    }

                    if (buttonText) {
                      var atcBtnHTML = '<div data-variant-metafield="' + variant.id + '" class="' + (variant.id == selectedVariantId ? "" : "hidden") + '">';
                      atcBtnHTML += atcBtnTemplate;
                      atcBtnHTML += '</div>';

                      atcBtnHTML = atcBtnHTML.replace(/{{ buttonText }}/g, buttonText);
                      atcBtnHTML = atcBtnHTML.replace(/{{ buttonBuyNowText }}/g, buttonBuyNowText);
                      atcBtnHTML = atcBtnHTML.replace(/{{ preOrderBtnClass }}/g, preOrderBtnClass);
                      if (disableButton) {
                        atcBtnHTML = atcBtnHTML.replace('disabled-or-not', 'disabled');
                      }

                      pdpAtcBtnElement.innerHTML = pdpAtcBtnElement.innerHTML + atcBtnHTML;
                    }
                  }
                });

                pdpStockStatusElement.classList.remove('hidden');

                // add to cart from product data object
                if (pdpAtcBtnElement.innerHTML) {
                  pdpAtcBtnElement.classList.remove('hidden');

                  // hide the default add to cart button
                  const pdpDefaultAtcBtnElement = pdpProductContentElement.querySelector('.default-atc-btn');
                  if (pdpDefaultAtcBtnElement) {
                    pdpDefaultAtcBtnElement.style.display = 'none';
                  }

                  // apply content to other selectors
                  const pdpAtcBtnElements = pdpProductContentElement.querySelectorAll('.pdo-atc-btn');
                  if (pdpAtcBtnElements.length >= 2) {
                    const pdpAtcBtnElementHTML = pdpAtcBtnElement.innerHTML;

                    pdpAtcBtnElements.forEach(pdpAtcBtnElementItem => {
                      if (pdpAtcBtnElementItem.innerHTML == "") {
                        pdpAtcBtnElementItem.innerHTML = pdpAtcBtnElementHTML;
                        pdpAtcBtnElementItem.classList.remove('hidden');
                      }
                    });
                  }
                }

                // apply content to other selectors
                const pdpStockStatusElements = pdpProductContentElement.querySelectorAll('.pdo-stock-status');
                if (pdpStockStatusElements.length >= 2) {
                  const pdpStockStatusElementHTML = pdpStockStatusElement.innerHTML;

                  pdpStockStatusElements.forEach(pdpStockStatusElementItem => {
                    if (pdpStockStatusElementItem.innerHTML == "") {
                      pdpStockStatusElementItem.innerHTML = pdpStockStatusElementHTML;
                      pdpStockStatusElementItem.classList.remove('hidden');
                    }
                  });
                }
              }
            }

            /* GIFT PRODUCTS */
            var giftAmount = 0;

            if (pdpProductDetailsElement && productData.upsellData) {
              const pdpGiftProductsElement = pdpProductDetailsElement.querySelector('.pdo-gift-products');
              if (pdpGiftProductsElement) {
                // list the products
                const giftProductsItemsElement = pdpGiftProductsElement.querySelector('.items');
                if (giftProductsItemsElement) {
                  const giftProductTemplate = giftProductsItemsElement.innerHTML;
                  giftProductsItemsElement.innerHTML = "";

                  const upsellData = productData.upsellData;

                  var giftProductIds = [];
                  upsellData.map(function (upsellItem) {
                    if (upsellItem.discountPercent >= 100) {
                      const giftProducts = upsellItem.products;
                      giftProducts.map(function (giftProduct) {
                        if (giftProduct.available) {
                          // ignore existed gift products
                          if (!giftProductIds.includes(giftProduct.id)) {
                            giftAmount += giftProduct.discountedPrice;

                            giftProductIds.push(giftProduct.id);

                            var giftProductHTML = giftProductTemplate;
                            const imgUrl = '<img src="' + giftProduct.imgUrl + '" alt="' + giftProduct.title + '" />';
                      
                            giftProductHTML = giftProductHTML.replace(/{{ id }}/g, giftProduct.id);
                            giftProductHTML = giftProductHTML.replace(/{{ handle }}/g, giftProduct.handle);
                            giftProductHTML = giftProductHTML.replace(/{{ imgUrl }}/g, imgUrl);
                            giftProductHTML = giftProductHTML.replace(/{{ selectedVariantId }}/g, giftProduct.selectedVariantId);
                            giftProductHTML = giftProductHTML.replace(/{{ selectedVariantSku }}/g, giftProduct.selectedVariantSku);
                            giftProductHTML = giftProductHTML.replace(/{{ title }}/g, giftProduct.title);
                            giftProductHTML = giftProductHTML.replace(/{{ price }}/g, theme.Currency.formatMoney(giftProduct.discountedPrice * 100, theme.moneyFormat));
                            giftProductHTML = giftProductHTML.replace(/{{ compareAtPrice }}/g, theme.Currency.formatMoney(giftProduct.compareAtPrice * 100, theme.moneyFormat));
                            giftProductHTML = giftProductHTML.replace(/{{ savePercentage }}/g, upsellItem.discountPercent);
                            giftProductHTML = giftProductHTML.replace(/{{ quantity }}/g, giftProduct.quantity);

                            if (giftProduct.bundleData) {
                              giftProductHTML = giftProductHTML.replace(/{{ bundleData }}/g, JSON.stringify(giftProduct.bundleData));
                            } else {
                              giftProductHTML = giftProductHTML.replace(/{{ bundleData }}/g, '');
                            }

                            giftProductsItemsElement.innerHTML = giftProductsItemsElement.innerHTML + giftProductHTML;
                          }
                        }
                      });
                    }
                  });

                  if (giftProductIds.length) {
                    pdpGiftProductsElement.classList.remove('hidden');
                  }
                }
              }
            }

            // update free gifts badge
            const pcFreeGiftsBadgeElement = pdpProductContentElement.querySelector('.free-gifts-badge');
            if (pcFreeGiftsBadgeElement) {
              var pcFreeGiftsBadgeHTML = pcFreeGiftsBadgeElement.innerHTML;
              pcFreeGiftsBadgeHTML = pcFreeGiftsBadgeHTML.replace(/{{ giftAmount }}/g, theme.Currency.formatMoney(giftAmount * 100, theme.moneyFormat));
              pcFreeGiftsBadgeElement.innerHTML = pcFreeGiftsBadgeHTML;

              if (giftAmount) {
                pcFreeGiftsBadgeElement.classList.remove('hidden');
              }
            }

            /* BUNDLE PRODUCTS */
            if (pdpProductDetailsElement) {
              const pdpBundleProductsElement = pdpProductDetailsElement.querySelector('.pdo-bundle-products');
              if (pdpBundleProductsElement) {
                // prepare data for adding the bundle items to the cart
                const bundleProductsScriptElement = pdpBundleProductsElement.querySelector('[data-bundle-json]');
                if (bundleProductsScriptElement) {
                  if (productData.bundleData) {
                    bundleProductsScriptElement.innerHTML = bundleProductsScriptElement.innerHTML.replace(/{{ bundleData }}/g, JSON.stringify(productData.bundleData));
                  } else {
                    bundleProductsScriptElement.innerHTML = bundleProductsScriptElement.innerHTML.replace(/{{ bundleData }}/g, '');
                  }
                }

                // show the bundle items to the product page
                if (productData.bundleData) {
                  const bundleProductsItemsElement = pdpBundleProductsElement.querySelector('.items');
                  if (bundleProductsItemsElement) {
                    const bundleProductTemplate = bundleProductsItemsElement.innerHTML;
                    bundleProductsItemsElement.innerHTML = "";

                    const bundleData = productData.bundleData;

                    var bundleProductIds = []
                    bundleData.map(function (bundleItem) {
                      const bundleProducts = bundleItem.products;
                      bundleProducts.map(function (bundleProduct) {
                        bundleProductIds.push(bundleProduct.id);

                        var bundleProductHTML = bundleProductTemplate;
                        const imgUrl = '<img src="' + bundleProduct.imgUrl + '" alt="' + bundleProduct.title + '" />'
                  
                        bundleProductHTML = bundleProductHTML.replace(/{{ handle }}/g, bundleProduct.handle);
                        bundleProductHTML = bundleProductHTML.replace(/{{ title }}/g, bundleProduct.title);
                        bundleProductHTML = bundleProductHTML.replace(/{{ imgUrl }}/g, imgUrl);
                        bundleProductHTML = bundleProductHTML.replace(/{{ quantity }}/g, bundleProduct.quantity);

                        bundleProductsItemsElement.innerHTML = bundleProductsItemsElement.innerHTML + bundleProductHTML;
                      });
                    });

                    if (bundleProductIds.length) {
                      pdpBundleProductsElement.classList.remove('hidden');

                      var pdpBundleProductsFlkty = new Flickity(bundleProductsItemsElement, {
                        prevNextButtons: true,
                        pageDots: false,
                        wrapAround: false,
                        contain: true,
                        cellAlign: "left",
                        dragThreshold: 8,
                        groupCells: true,
                        arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
                      });
                      setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                      }, 200);
                    }
                  }
                }
              }
            }

            /* UPSELL PRODUCTS */
            if (pdpProductDetailsElement && productData.upsellData) {
              const pdpUpsellProductsElement = pdpProductDetailsElement.querySelector('.pdo-upsell-products');
              if (pdpUpsellProductsElement) {
                // update the save up to percentage
                const upsellProductsIntroElement = pdpUpsellProductsElement.querySelector('.intro');
                if (upsellProductsIntroElement) {
                  var upsellProductsIntroHTML = upsellProductsIntroElement.innerHTML;
                  upsellProductsIntroHTML = upsellProductsIntroHTML.replace(/{{ saveUpToPercentage }}/g, productData.saveUpToPercentage);
                  if (productData.saveUpToPercentage <= 0) {
                    upsellProductsIntroHTML = upsellProductsIntroHTML.replace(/{{ saveUpToPercentageClass }}/g, 'hidden');
                  } else {
                    upsellProductsIntroHTML = upsellProductsIntroHTML.replace(/{{ saveUpToPercentageClass }}/g, '');
                  }
                  upsellProductsIntroElement.innerHTML = upsellProductsIntroHTML;
                }

                // list the products
                const upsellProductsItemsElement = pdpUpsellProductsElement.querySelector('.items');
                if (upsellProductsItemsElement) {
                  const upsellProductTemplate = upsellProductsItemsElement.innerHTML;
                  upsellProductsItemsElement.innerHTML = "";

                  const upsellData = productData.upsellData;

                  // ignore gift products
                  var giftProductIds = [];
                  upsellData.map(function (upsellItem) {
                    if (upsellItem.discountPercent >= 100) {
                      const upsellProducts = upsellItem.products;
                      upsellProducts.map(function (upsellProduct) {
                        giftProductIds.push(upsellProduct.id);
                      });
                    }
                  });

                  var upsellProductIds = []
                  upsellData.map(function (upsellItem) {
                    if (upsellItem.discountPercent < 100) {
                      const upsellProducts = upsellItem.products;
                      upsellProducts.map(function (upsellProduct) {
                        if (upsellProduct.available) {
                          // check available for bundle product
                          var upsellProductStockTextType = upsellProduct.stockTextType;

                          const bundleStatus = getBundleStatus(upsellProduct.bundleData);
                          const bundleStockTextType = bundleStatus.bundleStockTextType;
                          if (bundleStockTextType) {
                            upsellProductStockTextType = bundleStockTextType;
                          }

                          if (upsellProductStockTextType != 'soldout') {
                            if (!giftProductIds.includes(upsellProduct.id)) {
                              // ignore existed upsell products
                              if (!upsellProductIds.includes(upsellProduct.id)) {
                                upsellProductIds.push(upsellProduct.id);

                                var upsellProductHTML = upsellProductTemplate;
                                const imgUrl = '<img src="' + upsellProduct.imgUrl + '" alt="' + upsellProduct.title + '" />';
                          
                                upsellProductHTML = upsellProductHTML.replace(/{{ id }}/g, upsellProduct.id);
                                upsellProductHTML = upsellProductHTML.replace(/{{ handle }}/g, upsellProduct.handle);
                                upsellProductHTML = upsellProductHTML.replace(/{{ imgUrl }}/g, imgUrl);

                                if (upsellProduct.showQuantity) {
                                  upsellProductHTML = upsellProductHTML.replace(/{{ quantitySelectorClass }}/g, '');
                                } else {
                                  upsellProductHTML = upsellProductHTML.replace(/{{ quantitySelectorClass }}/g, 'hidden');
                                }

                                upsellProductHTML = upsellProductHTML.replace(/{{ selectedVariantId }}/g, upsellProduct.selectedVariantId);
                                upsellProductHTML = upsellProductHTML.replace(/{{ selectedVariantSku }}/g, upsellProduct.selectedVariantSku);
                                upsellProductHTML = upsellProductHTML.replace(/{{ title }}/g, upsellProduct.title);
                                upsellProductHTML = upsellProductHTML.replace(/{{ price }}/g, theme.Currency.formatMoney(upsellProduct.discountedPrice * 100, theme.moneyFormat));
                                upsellProductHTML = upsellProductHTML.replace(/{{ compareAtPrice }}/g, theme.Currency.formatMoney(upsellProduct.compareAtPrice * 100, theme.moneyFormat));

                                // upsellProductHTML = upsellProductHTML.replace(/{{ savePercentage }}/g, upsellItem.discountPercent);

                                const upsellItemDiscountPercentage = Math.floor((1 - (upsellProduct.discountedPrice / upsellProduct.compareAtPrice)) * 100);
                                upsellProductHTML = upsellProductHTML.replace(/{{ savePercentage }}/g, upsellItemDiscountPercentage);

                                if (upsellProduct.bundleData) {
                                  upsellProductHTML = upsellProductHTML.replace(/{{ bundleData }}/g, JSON.stringify(upsellProduct.bundleData));
                                } else {
                                  upsellProductHTML = upsellProductHTML.replace(/{{ bundleData }}/g, '');
                                }

                                upsellProductsItemsElement.innerHTML = upsellProductsItemsElement.innerHTML + upsellProductHTML;
                              }
                            }
                          }
                        }
                      });
                    }
                  });

                  if (upsellProductIds.length) {
                    pdpUpsellProductsElement.classList.remove('hidden');

                    // behaviour on input checking
                    const upsellVariantInputs = upsellProductsItemsElement.querySelectorAll('input[name="upsell_variant_id"]');
                    if (upsellVariantInputs.length) {
                      upsellVariantInputs.forEach(upsellVariantInput => {
                        upsellVariantInput.addEventListener('change', function() {
                          const upsellItemElement = upsellVariantInput.closest('.item');
                          if (upsellItemElement) {
                            if (upsellVariantInput.checked) {
                              upsellItemElement.classList.add('selected');
                            } else {
                              upsellItemElement.classList.remove('selected');
                            }
                          }
                        });
                      });
                    }

                    initQuantitySelector();
                  }
                }
              }
            }

            /* CROSSSELL PRODUCTS */
            updateCrosssellItemsModal('crosssellItemsModal-' + productId, productData.crossSellData);
            /* end CROSSSELL PRODUCTS */

            /* LINKED VARIANTS */
            if (pdpProductContentElement && productData.linkedVariantsData) {
              const variantProductsElement = pdpProductContentElement.querySelector('.variant-products');
              if (variantProductsElement) {
                linkedVariantsData = productData.linkedVariantsData;
                linkedVariantsData.map(function (linkedVariant) {
                  const linkedVariantProducts = linkedVariant.products;
                  linkedVariantProducts.map(function (linkedVariantProduct) {
                    var linkedVariantProductStockTextType = linkedVariantProduct.stockTextType;

                    const bundleStatus = getBundleStatus(linkedVariantProduct.bundleData);
                    const bundleStockTextType = bundleStatus.bundleStockTextType;
                    if (bundleStockTextType) {
                      linkedVariantProductStockTextType = bundleStockTextType;
                    }

                    const linkedVariantProductId = linkedVariantProduct.id;
                    const linkedVariantProductElement = variantProductsElement.querySelector('#variant-product-' + linkedVariantProductId);
                    if (linkedVariantProductElement) {
                      const linkedVariantProductDataStockTypeElement = linkedVariantProductElement.querySelector('.data-stock-type');
                      if (linkedVariantProductDataStockTypeElement) {
                        linkedVariantProductDataStockTypeElement.setAttribute('data-stock-type', linkedVariantProductStockTextType);
                      }
                    }
                  });
                });
              }
            }
            /* end LINKED VARIANTS */
          }

          // move atc-mobile for floating
          if (pdpProductContentElement) {
            const atcMobileElement = pdpProductContentElement.querySelector('.atc-mobile');
            const atcButton = pdpProductContentElement.querySelector('.product-info__add-button');

            if (atcMobileElement && atcButton) {
              pdpProductContentElement.appendChild(atcMobileElement);

              window.addEventListener('scroll', () => {
                const addButtonRect = atcButton.getBoundingClientRect();
                
                const storeHeaderElement = document.body.querySelector('store-header');
                var storeHeaderHeight = 0;
                if (storeHeaderElement) {
                  storeHeaderHeight = storeHeaderElement.offsetHeight - 1;
                }

                if (addButtonRect.top <= 0) {
                  if (storeHeaderHeight) {
                    atcMobileElement.style.top = storeHeaderHeight + 'px';
                  } else {
                    atcMobileElement.style.top = '0';
                  }
                } else {
                  atcMobileElement.style.top = '-200px';
                }
              });
            }
          }
        })
        .catch(error => {
          console.error('Failed to get content:', error);
        });
    }
  }
}

if (window.theme.template.includes('product')) {
  Dtails.ProductUpdater.init();
}

/* MODALS */
document.addEventListener('DOMContentLoaded', function() {
  const openModalButtons = document.querySelectorAll('.open-modal-btn');
  const allModals = document.querySelectorAll('.modal');

  function showModal(modalElement) {
    if (!modalElement) return;

    modalElement.style.display = 'block';
    modalElement.offsetWidth;
    modalElement.classList.add('show');
    document.body.classList.add('modal-open');
  }

  function hideModal(modalElement) {
    if (!modalElement) return;

    modalElement.classList.remove('show');
    document.body.classList.remove('modal-open');

    const transitionEndHandler = function() {
      modalElement.style.display = 'none';
      modalElement.removeEventListener('transitionend', transitionEndHandler);
    };
    modalElement.addEventListener('transitionend', transitionEndHandler);
  }

  openModalButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetModalSelector = this.dataset.target;
      const targetModal = document.querySelector(targetModalSelector);
      showModal(targetModal);
    });
  });

  allModals.forEach(modal => {
    const closeButtons = modal.querySelectorAll('.close, .close-modal-btn');
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        hideModal(modal);
      });
    });

    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        hideModal(modal);
      }
    });
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const activeModal = document.querySelector('.modal.show');
      if (activeModal) {
        hideModal(activeModal);
      }
    }
  });
});

/* Grouped videos section */
document.addEventListener('DOMContentLoaded', () => {
  // video lazy load
  const lazyVideos = document.querySelectorAll('.ugc-video__Video');
  const lazyLoadVideo = (video) => {
    const source = video.querySelector('source[data-src]');
    if (source && !source.src) {
      source.src = source.dataset.src;
      video.load();
    }
  };
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        lazyLoadVideo(video);
        observer.unobserve(video);
      }
    });
  });
  lazyVideos.forEach(video => observer.observe(video));

  // video play/pause button
  const videoContainers = document.querySelectorAll('.ugc-video');
  videoContainers.forEach(container => {
    const video = container.querySelector('.ugc-video__Video');
    const playButton = container.querySelector('.ugc-video__play-button');
    const pauseButton = container.querySelector('.ugc-video__pause-button');
    let fadeOutTimeout;

    const updateButtonVisibility = () => {
      if (video.paused) {
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
        playButton.style.opacity = 1;
      } else {
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
        resetFadeOutTimer();
      }
    };

    const resetFadeOutTimer = () => {
      clearTimeout(fadeOutTimeout);
      if (!video.paused) {
        pauseButton.style.opacity = 1;
        fadeOutTimeout = setTimeout(() => {
          pauseButton.style.opacity = 0;
        }, 3000);
      }
    };

    const togglePlayPause = () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      updateButtonVisibility();
    };

    playButton.addEventListener('click', togglePlayPause);
    pauseButton.addEventListener('click', togglePlayPause);
    video.addEventListener('ended', updateButtonVisibility);
    video.addEventListener('mousemove', resetFadeOutTimer);
    video.addEventListener('click', resetFadeOutTimer);
    video.addEventListener('touchstart', resetFadeOutTimer);
    video.addEventListener('touchmove', resetFadeOutTimer);

    updateButtonVisibility();
  });

  // video carousel
  var videoListElements = document.querySelectorAll('.ugc-videoList');
  videoListElements.forEach(videoListElement => {
    if (videoListElement) {
      var videoListFlkty = new Flickity(videoListElement, {
        freeScroll: true,
        contain: true,
        pageDots: false,
        cellAlign: "left",
        wrapAround: true,
        arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
      });
    }
  });
});
/* end Grouped videos section */

/* Judge.me reviews slider */
document.addEventListener('DOMContentLoaded', function () {
  const reviewsSliderSection = document.querySelector('.judgeme-slider-section');
  if (!reviewsSliderSection) {
    return false;
  }
  
  const reviewsJsonUrl = reviewsSliderSection.dataset.reviewsJsonUrl;
  const reviewsCount = reviewsSliderSection.dataset.reviewsCount;
  if (reviewsJsonUrl == '' || reviewsCount == '') {
    return false;
  }

  const reviewsSliderElement = reviewsSliderSection.querySelector('.judgeme-review-slider');
  if (!reviewsSliderElement) {
    return false;
  }

  const sliderTitleElement = reviewsSliderSection.querySelector('.review-slider-title');

  function generateRoundedStars(rating) {
    const filledStar = `
      <svg class="svg-star" viewBox="0 0 24 24" fill="#58E0AF" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C12.3 2 12.6 2.2 12.7 2.5L14.9 8.4L21.2 9.1C21.6 9.2 21.8 9.6 21.6 9.9L17.2 14.3L18.5 20.5C18.6 20.9 18.1 21.2 17.8 21L12 17.7L6.2 21C5.9 21.2 5.4 20.9 5.5 20.5L6.8 14.3L2.4 9.9C2.2 9.6 2.4 9.2 2.8 9.1L9.1 8.4L11.3 2.5C11.4 2.2 11.7 2 12 2Z"/>
      </svg>`;
    const emptyStar = `
      <svg class="svg-star" viewBox="0 0 24 24" fill="none" stroke="#58E0AF" stroke-width="1.5" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C12.3 2 12.6 2.2 12.7 2.5L14.9 8.4L21.2 9.1C21.6 9.2 21.8 9.6 21.6 9.9L17.2 14.3L18.5 20.5C18.6 20.9 18.1 21.2 17.8 21L12 17.7L6.2 21C5.9 21.2 5.4 20.9 5.5 20.5L6.8 14.3L2.4 9.9C2.2 9.6 2.4 9.2 2.8 9.1L9.1 8.4L11.3 2.5C11.4 2.2 11.7 2 12 2Z"/>
      </svg>`;
  
    let stars = '';
    for (let i = 1; i <= 5; i++) {
      stars += i <= rating ? filledStar : emptyStar;
    }
    return stars;
  }
  
  fetch(reviewsJsonUrl)
    .then(res => res.json())
    .then(data => {
      // Set headline text
      if (sliderTitleElement && data.headline) {
        sliderTitleElement.textContent = data.headline;
      }
    
      const reviews = data.reviews.slice(0, reviewsCount);
      reviews.forEach(review => {
        const card = document.createElement('div');
        card.className = 'review-card';

        const stars = generateRoundedStars(review.rating);
        const reviewerName = review.name || 'Anonymous';
        const reviewTitle = review.title || '';
        let reviewBody = review.body || '';
        let shortReview = reviewBody;        
        // If reviewBody is longer than N characters, shorten it and add "...read more"
        if (reviewBody.length > 90) {
          shortReview = reviewBody.slice(0, 90) + '... <span class="read-more">Read more</span>';
        }
        let productUrl = review.product_url || '#';
        if (productUrl.startsWith('/products/') === false) {
          productUrl = '/products' + (productUrl.startsWith('/') ? '' : '/') + productUrl;
        }
        const linkText = review.product_link_text || 'View Product';
        const profileImg = review.profile_image || 'https://cdn.shopify.com/s/files/1/0621/4094/0468/files/frying-pan.png?v=1747825989';

        card.innerHTML = `
          <div class="profile-icon">
            <img src="${profileImg}" alt="Avatar of ${reviewerName}" class="profile-img"/>
          </div>
          <div class="reviewer-name">${reviewerName}</div>
          <div class="stars">${stars}</div>
          <p class="review-title">${reviewTitle}</p>
          <p class="review-body" data-full-text="${reviewBody.replace(/"/g, '&quot;')}">${shortReview}</p>
          <div class="product-link"><a class="text-current" href="${productUrl}" target="_blank">${linkText}</a></div>
        `;

        reviewsSliderElement.appendChild(card);
      });

      const updatedReviewsSliderSection = document.querySelector('.judgeme-slider-section');

      // Initialize carousel
      const updatedReviewsSliderElement = updatedReviewsSliderSection.querySelector('.judgeme-review-slider');
      if (updatedReviewsSliderElement) {
        var reviewsSliderFlkty = new Flickity(updatedReviewsSliderElement, {
          freeScroll: true,
          contain: true,
          cellAlign: "left",
          wrapAround: true,
          prevNextButtons: false
        });
      }

      // Attach click event to all .read-more spans
      updatedReviewsSliderSection.querySelectorAll('.read-more').forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          const parentParagraph = this.closest('.review-body');
          if (parentParagraph) {
            const fullText = parentParagraph.getAttribute('data-full-text');
            parentParagraph.innerHTML = fullText; // Replace the short text with full text
          }
        });
      });
    })
    .catch(err => console.error('Custom reviews JSON load error:', err));
});
/* end Judge.me reviews slider */

/* Cart crosssell */
window.cartCrosssellSliderItemsFlkty = null;
Dtails.CartCrosssell = {
  init: function () {
    this.updateCartCrosssell();
  },
  updateCartCrosssell() {
    let cartCrosssellProductIds = [];
    const cartCrosssellProductIdInputElements = document.querySelectorAll('.cart-crosssell-product-id-input');
    if (cartCrosssellProductIdInputElements.length) {
      cartCrosssellProductIdInputElements.forEach(cartCrosssellProductIdInputElement => {
        const cartItemElement = cartCrosssellProductIdInputElement.closest('.cart-item');
        if (cartItemElement) {
          const parentVariantId = cartItemElement.dataset.variantId;

          if (cartCrosssellProductIdInputElement.value) {
            cartCrosssellProductIds.push(parentVariantId + '-' + cartCrosssellProductIdInputElement.value);
          }
        }
      });
    }

    // hide the cart crosssell first
    const cartDrawerElement = document.querySelector('#cart-drawer');
    if (cartDrawerElement) {
      cartDrawerElement.classList.add('no-cart-crosssell');
    }

    const cartCrosssellElement = document.querySelector('#cart-crosssell');
    const cartCrosssellSliderElement = document.querySelector('#cart-crosssell-slider');

    if (cartCrosssellElement) {
      // clear the current items
      const cartCrosssellItemsElement = cartCrosssellElement.querySelector('.items');
      if (cartCrosssellItemsElement) {
        cartCrosssellItemsElement.innerHTML = '';
      }

      if (cartCrosssellSliderElement) {
        if (window.cartCrosssellSliderItemsFlkty) {
          window.cartCrosssellSliderItemsFlkty.destroy();
          window.cartCrosssellSliderItemsFlkty = null;
        }

        const cartCrosssellSliderItemsElement = cartCrosssellSliderElement.querySelector('.items');
        if (cartCrosssellSliderItemsElement) {
          cartCrosssellSliderItemsElement.innerHTML = '';
        }
      }

      if (cartCrosssellProductIds.length) {
        // get product data
        let pdoURL = window.routes.searchUrl + '?view=product-data-object&type=product&q=id:' + cartCrosssellProductIds[0].split('-')[1];
        cartCrosssellProductIds.forEach((cartCrosssellProductId, index) => {
          if (index > 0) {
            const productId = cartCrosssellProductId.split('-')[1];
            pdoURL += ' OR id:' + productId;
          }
        });

        getUrlContent(pdoURL)
          .then(content => {
            const response = JSON.parse(content);

            // prepare cart crosssell product item data
            let cartCrosssellProductItems = [];
            response.forEach(item => {
              const productId = Object.keys(item)[0];
              if (productId && item[productId] && Array.isArray(item[productId]) && item[productId].length > 0) {
                const productObject = item[productId][0];
                if (productObject.cartCrossSellData) {
                  const cartCrossSellData = productObject.cartCrossSellData;
                  if (cartCrossSellData && cartCrossSellData.length) {
                    // get parent variant ID
                    let parentVariantId = 0;
                    cartCrosssellProductIds.forEach((cartCrosssellProductId) => {
                      const pId = cartCrosssellProductId.split('-')[1];
                      if (pId == productId) {
                        parentVariantId = cartCrosssellProductId.split('-')[0];
                      }
                    });

                    if (parentVariantId) {
                      cartCrossSellData.forEach(cartCrossSellDataItem => {
                        const cartCrosssellProducts = cartCrossSellDataItem.products;
                        if (cartCrosssellProducts.length) {
                          cartCrosssellProducts.forEach(cartCrosssellProduct => {
                            let cartCrosssellDataItemProduct = {};
                            cartCrosssellDataItemProduct[parentVariantId] = cartCrosssellProduct;
                            cartCrosssellDataItemProduct[parentVariantId]['discountPercent'] = cartCrossSellDataItem.discountPercent
                            cartCrosssellProductItems.push(cartCrosssellDataItemProduct);
                          });
                        }
                      });
                    }
                  }
                }
              }
            });

            // render cart crosssell product item
            if (cartCrosssellProductItems.length) {
              let cartCrosssellItemTemplateHTML = '';
              let addToCartText = '';
              let soldOutText = '';
              let preOrderText = '';
              const cartCrosssellItemTemplateElement = cartCrosssellElement.querySelector('.item-template');
              if (cartCrosssellItemTemplateElement) {
                cartCrosssellItemTemplateHTML = cartCrosssellItemTemplateElement.innerHTML;

                const cartCrosssellAtcBtnElement = cartCrosssellItemTemplateElement.querySelector('.button-holder');
                if (cartCrosssellAtcBtnElement) {
                  addToCartText = cartCrosssellAtcBtnElement.dataset.addToCartText;
                  soldOutText = cartCrosssellAtcBtnElement.dataset.soldOutText;
                  preOrderText = cartCrosssellAtcBtnElement.dataset.preOrderText;
                }
              }

              if (cartCrosssellItemTemplateHTML) {
                let existedCartVariantIds = [];
                document.querySelectorAll('.cart-item').forEach((cartItem) => {
                  if (cartItem.dataset.variantId) {
                    existedCartVariantIds.push(cartItem.dataset.variantId);
                  }
                });

                let countCartCrosssellProductItem = 0;
                let newCartCrosssellItemsHTML = '';
                cartCrosssellProductItems.forEach(cartCrosssellProductItem => {
                  const parentVariantId = Object.keys(cartCrosssellProductItem)[0];
                  if (parentVariantId && cartCrosssellProductItem[parentVariantId]) {
                    const cartCrosssellProductObject = cartCrosssellProductItem[parentVariantId];

                    if (cartCrosssellProductObject.available) {
                      // check existed ?
                      const selectedVariantIdString = cartCrosssellProductObject.selectedVariantId + '';
                      if (!existedCartVariantIds.includes(selectedVariantIdString) && countCartCrosssellProductItem < theme.settings.cartCrosssellLimit) {
                        countCartCrosssellProductItem++;

                        let newCartCrosssellItemHTML = cartCrosssellItemTemplateHTML;

                        const imgUrl = '<img src="' + cartCrosssellProductObject.imgUrl + '" alt="' + cartCrosssellProductObject.title + '" />';
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ imgUrl }}/g, imgUrl);
                      
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ parentVariantId }}/g, parentVariantId);
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ discountParentId }}/g, parentVariantId);
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ handle }}/g, cartCrosssellProductObject.handle);
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ title }}/g, cartCrosssellProductObject.titleTag.replace('[title]', cartCrosssellProductObject.title));
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ selectedVariantId }}/g, cartCrosssellProductObject.selectedVariantId);
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ price }}/g, theme.Currency.formatMoney(cartCrosssellProductObject.discountedPrice * 100, theme.moneyFormat));
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ compareAtPrice }}/g, theme.Currency.formatMoney(cartCrosssellProductObject.compareAtPrice * 100, theme.moneyFormat));
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ quantity }}/g, cartCrosssellProductObject.quantity);

                        // discount percent
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ savePercentage }}/g, cartCrosssellProductObject.discountPercent);
                        if (cartCrosssellProductObject.discountPercent <= 0) {
                          newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ customSaveClass }}/g, 'hidden');
                        } else {
                          newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ customSaveClass }}/g, '');
                        }

                        // bundle data
                        if (cartCrosssellProductObject.bundleData) {
                          newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ bundleData }}/g, JSON.stringify(cartCrosssellProductObject.bundleData));
                        } else {
                          newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ bundleData }}/g, '');
                        }

                        // bundle stock status
                        const bundleStatus = getBundleStatus(cartCrosssellProductObject.bundleData);
                        const bundleStockTextType = bundleStatus.bundleStockTextType;
                        const bundleStockStatusText = bundleStatus.bundleStockStatusText;

                        // stock status
                        var variantStockTextType = cartCrosssellProductObject.stockTextType;
                        if (bundleStockTextType) {
                          variantStockTextType = bundleStockTextType;
                        }
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ stockTextType }}/g, variantStockTextType);
                        
                        if (bundleStockStatusText) {
                          newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ stockStatusText }}/g, bundleStockStatusText);
                        } else {
                          newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ stockStatusText }}/g, cartCrosssellProductObject.stockStatusText);
                        }

                        // add to cart
                        var buttonText = '';
                        var preOrderBtnClass = '';
                        var disableButton = false;
                        if (variantStockTextType == 'instock') {
                          buttonText = addToCartText;
                        }
                        if (variantStockTextType == 'preorder_remote_stock' || variantStockTextType == 'preorder_with_available_date' || variantStockTextType == 'preorder_with_passed_date' || variantStockTextType == 'preorder_with_unknown_date') {
                          buttonText = preOrderText;
                          preOrderBtnClass = 'btn-pre-order';
                        }
                        if (variantStockTextType == 'soldout' || variantStockTextType == 'soldout_with_available_date') {
                          buttonText = soldOutText;
                          disableButton = true;
                        }

                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ buttonText }}/g, buttonText);
                        newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace(/{{ preOrderBtnClass }}/g, preOrderBtnClass);
                        if (disableButton) {
                          newCartCrosssellItemHTML = newCartCrosssellItemHTML.replace('disabled-or-not', 'disabled');
                        }

                        newCartCrosssellItemsHTML += newCartCrosssellItemHTML;
                      }
                    }
                  }
                });

                if (newCartCrosssellItemsHTML && cartDrawerElement) {
                  cartCrosssellItemsElement.innerHTML = newCartCrosssellItemsHTML;

                  // update cart crosssell slider
                  if (cartCrosssellSliderElement) {
                    const cartCrosssellSliderItemsElement = cartCrosssellSliderElement.querySelector('.items');
                    if (cartCrosssellSliderItemsElement) {
                      cartCrosssellSliderItemsElement.innerHTML = newCartCrosssellItemsHTML;

                      window.cartCrosssellSliderItemsFlkty = new Flickity(cartCrosssellSliderItemsElement, {
                        freeScroll: false,
                        contain: true,
                        pageDots: true,
                        prevNextButtons: false,
                        cellAlign: "left",
                        wrapAround: false
                      });

                      setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                      }, 200);
                    }
                  }

                  cartDrawerElement.classList.remove('no-cart-crosssell');

                  // add to cart function
                  const cartCrosssellAtcFormElements = document.querySelectorAll('.cart-crosssell-atc-form');
                  const productFormElement = document.querySelector('product-form');

                  if (cartCrosssellAtcFormElements.length) {
                    cartCrosssellAtcFormElements.forEach(function (cartCrosssellAtcFormElement, index) {
                      cartCrosssellAtcFormElement.addEventListener('submit', function(e) {
                        e.preventDefault();

                        if (productFormElement && typeof productFormElement.addToCart === 'function') {
                          var cartCrosssellFormData = new FormData();

                          var cartCrosssellVariantId = '';
                          const cartCrosssellVariantIdInput = cartCrosssellAtcFormElement.querySelector('input[name="selected_variant_id"]');
                          if (cartCrosssellVariantIdInput) {
                            cartCrosssellVariantId = cartCrosssellVariantIdInput.value;
                          }
                          cartCrosssellFormData.append('items[' + index + '][id]', cartCrosssellVariantId);

                          var quantity = 1;
                          const quantityInput = cartCrosssellAtcFormElement.querySelector('input[name="quantity"]');
                          if (quantityInput) {
                            quantity = quantityInput.value;
                          }
                          cartCrosssellFormData.append('items[' + index + '][quantity]', quantity);

                          cartCrosssellFormData.append('items[' + index + '][properties][_AddedFrom]', 'cart-cross-sell');

                          const savePercentageInput = cartCrosssellAtcFormElement.querySelector('input[name="save_percentage"]');
                          if (savePercentageInput) {
                            const savePercentage = savePercentageInput.value;
                            cartCrosssellFormData.append('items[' + index + '][properties][_du]', savePercentage);

                            const hash = sha256("gid://shopify/ProductVariant/" + cartCrosssellVariantId + "," + savePercentage).hex();
                            cartCrosssellFormData.append('items[' + index + '][properties][_dh]', hash);
                          }

                          cartCrosssellFormData.append('items[' + index + '][properties][_discount_quantity]', quantity);

                          const parentVariantIdInput = cartCrosssellAtcFormElement.querySelector('input[name="parent_variant_id"]');
                          if (parentVariantIdInput) {
                            const parentVariantId = parentVariantIdInput.value;
                            cartCrosssellFormData.append('items[' + index + '][properties][_variant_id_parent]', parentVariantId);
                          }

                          const discountParentIdInput = cartCrosssellAtcFormElement.querySelector('input[name="discount_parent_id"]');
                          if (discountParentIdInput) {
                            const discountParentId = discountParentIdInput.value;
                            cartCrosssellFormData.append('items[' + index + '][properties][_discount_parent]', discountParentId);
                          }

                          // add crosssell bundle items
                          let cartCrosssellIsAllChildsPrepacked = true;
                          var cartCrosssellBundleProductIds = []
                          var cartCrosssellBundleTitles = [];
                          var cartCrosssellBundleVariantIds = [];
                          var cartCrosssellBundleStockProperties = [];
                          var cartCrosssellBundleItemsText = 'Bundle items';

                          const cartCrosssellBundleDataScriptElement = cartCrosssellAtcFormElement.querySelector('script[type="application/json"][data-bundle-json]');
                          if (cartCrosssellBundleDataScriptElement) {
                            if (cartCrosssellBundleDataScriptElement.dataset.bundleItemsText) {
                              cartCrosssellBundleItemsText = cartCrosssellBundleDataScriptElement.dataset.bundleItemsText;
                            }
                            
                            const cartCrosssellBundleDataContent = cartCrosssellBundleDataScriptElement.textContent;
                            if (cartCrosssellBundleDataContent) {
                              const cartCrosssellBundleData = JSON.parse(cartCrosssellBundleDataContent);
                              cartCrosssellBundleData.map(function (cartCrosssellBundleItem) {
                                if (!cartCrosssellBundleItem.isPrepacked) {
                                  cartCrosssellIsAllChildsPrepacked = false;
                                }

                                const cartCrosssellBundleProducts = cartCrosssellBundleItem.products;
                                cartCrosssellBundleProducts.map(function (cartCrosssellBundleProduct) {
                                  cartCrosssellBundleProductIds.push(cartCrosssellBundleProduct.id);

                                  cartCrosssellBundleTitles.push(cartCrosssellBundleProduct.quantity + ' x ' + cartCrosssellBundleProduct.title);

                                  if (!cartCrosssellBundleItem.isPrepacked) {
                                    cartCrosssellBundleVariantIds.push(cartCrosssellBundleProduct.quantity + ' x ' + cartCrosssellBundleProduct.selectedVariantId);
                                  }
                                });
                              });
                            }
                          }

                          if (cartCrosssellBundleProductIds.length) {
                            //crosssellFormData.append('items[' + index + ']properties[_bundle_id]', Math.random().toString(36).substring(2, 15));
                            cartCrosssellFormData.append('items[' + index + ']properties[_bundle_titles]', cartCrosssellBundleTitles.join(','));
                            cartCrosssellFormData.append('items[' + index + ']properties[_bundle_variant_ids]', cartCrosssellBundleVariantIds.join(','));
                            cartCrosssellFormData.append('items[' + index + ']properties[_bundle_stock_properties]', '');
                            if (cartCrosssellIsAllChildsPrepacked) {
                              cartCrosssellFormData.append('items[' + index + ']properties[' + cartCrosssellBundleItemsText + ']', cartCrosssellBundleTitles.join(', '));
                            }
                          }

                          productFormElement.addToCart(cartCrosssellFormData, false, false, cartCrosssellAtcFormElement);
                        }
                      });
                    });
                  }
                }
              }
            }
          })
          .catch(error => {
            console.error('Failed to get content:', error);
          });
      }
    }
  }
}
Dtails.CartCrosssell.init();
/* end Cart crosssell */

/* Product card */
Dtails.ProductCard = {
  init: function () {
    this.updateProductCard();
  },
  updateProductCard() {
    let pcProductIds = [];
    let pdoPriceTemplate = '';
    let pdoStockStatusTemplate = '';
    let pdoAtcBtnTemplate = '';
    let pdoGiftProductItemTemplate = '';
    let addToCartText = '';
    let soldOutText = '';
    let preOrderText = '';

    const pcElements = document.querySelectorAll('product-card');
    if (pcElements.length) {
      pcElements.forEach(pcElement => {
        const pcProductId = pcElement.dataset.productId;
        if (pcProductId) {
          pcProductIds.push(pcProductId);

          const pdoPriceElement = pcElement.querySelector('.pdo-custom-price');
          if (pdoPriceTemplate == '' && pdoPriceElement) {
            pdoPriceTemplate = pdoPriceElement.innerHTML;
          }

          const pdoStockStatusElement = pcElement.querySelector('.pdo-stock-status');
          if (pdoStockStatusTemplate == '' && pdoStockStatusElement) {
            pdoStockStatusTemplate = pdoStockStatusElement.innerHTML;
          }

          const pcAtcBtnElement = pcElement.querySelector('.pdo-atc-btn');
          if (pdoAtcBtnTemplate == '' && pcAtcBtnElement) {
            // set the template
            pdoAtcBtnTemplate = pcAtcBtnElement.innerHTML;
            addToCartText = pcAtcBtnElement.dataset.addToCartText;
            soldOutText = pcAtcBtnElement.dataset.soldOutText;
            preOrderText = pcAtcBtnElement.dataset.preOrderText;
          }

          const pcGiftProductsItemsElement = pcElement.querySelector('.pdo-gift-products .items');
          if (pdoGiftProductItemTemplate == '' && pcGiftProductsItemsElement) {
            pdoGiftProductItemTemplate = pcGiftProductsItemsElement.innerHTML;
          }
        }
      });
    }

    if (pcProductIds.length) {
      // get product data
      let pdoURL = window.routes.searchUrl + '?view=product-data-object&type=product&q=id:' + pcProductIds[0];
      pcProductIds.forEach((pcProductId, index) => {
        if (index > 0) {
          pdoURL += ' OR id:' + pcProductId;
        }
      });

      getUrlContent(pdoURL)
        .then(content => {
          const response = JSON.parse(content);
          response.forEach(item => {
            const productId = Object.keys(item)[0];
            if (productId && item[productId] && Array.isArray(item[productId]) && item[productId].length > 0) {
              const productData = item[productId][0];
              const bundleData = productData.bundleData;
              const variants = productData.variants;

              const pcElement = document.querySelector('product-card[data-product-id="' + productId + '"]');
              if (pcElement) {
                // update price
                const pcPriceElement = pcElement.querySelector('.pdo-custom-price');
                if (pcPriceElement) {
                  let priceHTML = pdoPriceTemplate;

                  priceHTML = priceHTML.replace(/{{ price }}/g, theme.Currency.formatMoney(productData.price * 100, theme.moneyFormat));
                  priceHTML = priceHTML.replace(/{{ compareAtPrice }}/g, theme.Currency.formatMoney(productData.compareAtPrice * 100, theme.moneyFormat));
                  priceHTML = priceHTML.replace(/{{ savePercentage }}/g, productData.savePercentage);
                  priceHTML = priceHTML.replace(/{{ saveUpToPercentage }}/g, productData.saveUpToPercentage);

                  // show/hide the element
                  if (productData.savePercentage <= 0) {
                    priceHTML = priceHTML.replace(/{{ customSaveClass }}/g, 'hidden');
                  } else {
                    priceHTML = priceHTML.replace(/{{ customSaveClass }}/g, '');
                  }
                  priceHTML = priceHTML.replace(/{{ saveUpToPercentageClass }}/g, 'hidden'); // do not show this on the product card

                  // hide the default price
                  const pcDefaultPriceElement = pcElement.querySelector('.price--top');
                  if (pcDefaultPriceElement) {
                    pcDefaultPriceElement.classList.add('hidden');
                  }

                  // show the PDO price
                  pcPriceElement.innerHTML = priceHTML;
                  pcPriceElement.classList.remove('hidden');
                }

                // update stock status
                var variantStockTextType = variants[0].stockTextType;
                var variantStockStatusText = variants[0].stockStatusText;

                const pcStockStatusElement = pcElement.querySelector('.pdo-stock-status');
                if (pcStockStatusElement) {
                  let stockStatusHTML = pdoStockStatusTemplate;

                  const bundleStatus = getBundleStatus(bundleData);
                  const bundleStockTextType = bundleStatus.bundleStockTextType;
                  const bundleStockStatusText = bundleStatus.bundleStockStatusText;

                  if (bundleStockTextType) {
                    variantStockTextType = bundleStockTextType;
                  }
                  stockStatusHTML = stockStatusHTML.replace(/{{ stockTextType }}/g, variantStockTextType);

                  if (bundleStockStatusText) {
                    variantStockStatusText = bundleStockStatusText;
                  }
                  stockStatusHTML = stockStatusHTML.replace(/{{ stockStatusText }}/g, variantStockStatusText);

                  // show the PDO stock status
                  pcStockStatusElement.innerHTML = stockStatusHTML;
                  pcStockStatusElement.classList.remove('hidden');
                }

                // add to cart
                const pcAtcBtnElement = pcElement.querySelector('.pdo-atc-btn');
                if (pcAtcBtnElement) {
                  var buttonText = '';
                  var preOrderBtnClass = '';
                  var disableButton = false;
                  if (variantStockTextType == 'instock') {
                    buttonText = addToCartText;
                  }
                  if (variantStockTextType == 'preorder_remote_stock' || variantStockTextType == 'preorder_with_available_date' || variantStockTextType == 'preorder_with_passed_date' || variantStockTextType == 'preorder_with_unknown_date') {
                    buttonText = preOrderText;
                    preOrderBtnClass = 'btn-pre-order';
                  }
                  if (variantStockTextType == 'soldout' || variantStockTextType == 'soldout_with_available_date') {
                    buttonText = soldOutText;
                    disableButton = true;
                  }

                  if (buttonText) {
                    var atcBtnHTML = pdoAtcBtnTemplate;

                    atcBtnHTML = atcBtnHTML.replace(/{{ buttonText }}/g, buttonText);
                    atcBtnHTML = atcBtnHTML.replace(/{{ preOrderBtnClass }}/g, preOrderBtnClass);
                    if (disableButton) {
                      atcBtnHTML = atcBtnHTML.replace('disabled-or-not', 'disabled');
                    }

                    // hide the default add to cart button
                    const pcDefaultAtcBtnElement = pcElement.querySelector('.default-atc-btn');
                    if (pcDefaultAtcBtnElement) {
                      pcDefaultAtcBtnElement.setAttribute('aria-disabled', 'false');
                      pcDefaultAtcBtnElement.classList.remove('is-loading');
                      pcDefaultAtcBtnElement.style.display = 'none';
                    }

                    // show the PDO add to cart button
                    pcAtcBtnElement.innerHTML = atcBtnHTML;
                    pcAtcBtnElement.classList.remove('hidden');
                  }
                }

                // crosssell modal
                updateCrosssellItemsModal('crosssellItemsModal-' + productId, productData.crossSellData);

                // gift products
                var giftAmount = 0;

                const pcGiftProductsItemsElement = pcElement.querySelector('.pdo-gift-products .items');
                if (pcGiftProductsItemsElement) {
                  pcGiftProductsItemsElement.innerHTML = '';

                  const upsellData = productData.upsellData;

                  if (upsellData) {
                    var giftProductIds = [];
                    upsellData.map(function (upsellItem) {
                      if (upsellItem.discountPercent >= 100) {
                        const giftProducts = upsellItem.products;
                        giftProducts.map(function (giftProduct) {
                          if (giftProduct.available) {
                            // ignore existed gift products
                            if (!giftProductIds.includes(giftProduct.id)) {
                              giftProductIds.push(giftProduct.id);

                              giftAmount += giftProduct.discountedPrice;

                              var giftProductHTML = pdoGiftProductItemTemplate;
                              const imgUrl = '<img src="' + giftProduct.imgUrl + '" alt="' + giftProduct.title + '" />';
                        
                              giftProductHTML = giftProductHTML.replace(/{{ id }}/g, giftProduct.id);
                              giftProductHTML = giftProductHTML.replace(/{{ handle }}/g, giftProduct.handle);
                              giftProductHTML = giftProductHTML.replace(/{{ imgUrl }}/g, imgUrl);
                              giftProductHTML = giftProductHTML.replace(/{{ selectedVariantId }}/g, giftProduct.selectedVariantId);
                              giftProductHTML = giftProductHTML.replace(/{{ selectedVariantSku }}/g, giftProduct.selectedVariantSku);
                              giftProductHTML = giftProductHTML.replace(/{{ title }}/g, giftProduct.title);
                              giftProductHTML = giftProductHTML.replace(/{{ price }}/g, theme.Currency.formatMoney(giftProduct.discountedPrice * 100, theme.moneyFormat));
                              giftProductHTML = giftProductHTML.replace(/{{ compareAtPrice }}/g, theme.Currency.formatMoney(giftProduct.compareAtPrice * 100, theme.moneyFormat));
                              giftProductHTML = giftProductHTML.replace(/{{ savePercentage }}/g, upsellItem.discountPercent);
                              giftProductHTML = giftProductHTML.replace(/{{ quantity }}/g, giftProduct.quantity);

                              if (giftProduct.bundleData) {
                                giftProductHTML = giftProductHTML.replace(/{{ bundleData }}/g, JSON.stringify(giftProduct.bundleData));
                              } else {
                                giftProductHTML = giftProductHTML.replace(/{{ bundleData }}/g, '');
                              }

                              pcGiftProductsItemsElement.innerHTML = pcGiftProductsItemsElement.innerHTML + giftProductHTML;
                            }
                          }
                        });
                      }
                    });
                  }
                }

                // update free gifts badge
                const pcFreeGiftsBadgeElement = pcElement.querySelector('.free-gifts-badge');
                if (pcFreeGiftsBadgeElement) {
                  var pcFreeGiftsBadgeHTML = pcFreeGiftsBadgeElement.innerHTML;
                  pcFreeGiftsBadgeHTML = pcFreeGiftsBadgeHTML.replace(/{{ giftAmount }}/g, theme.Currency.formatMoney(giftAmount * 100, theme.moneyFormat));
                  pcFreeGiftsBadgeElement.innerHTML = pcFreeGiftsBadgeHTML;

                  if (giftAmount) {
                    pcFreeGiftsBadgeElement.classList.remove('hidden');
                  }
                }

                // bundle products
                const pcBundleProductsElement = pcElement.querySelector('.pdo-bundle-products');
                if (pcBundleProductsElement) {
                  const bundleProductsScriptElement = pcBundleProductsElement.querySelector('[data-bundle-json]');
                  if (bundleProductsScriptElement) {
                    if (productData.bundleData) {
                      bundleProductsScriptElement.innerHTML = bundleProductsScriptElement.innerHTML.replace(/{{ bundleData }}/g, JSON.stringify(productData.bundleData));
                    } else {
                      bundleProductsScriptElement.innerHTML = bundleProductsScriptElement.innerHTML.replace(/{{ bundleData }}/g, '');
                    }
                  }
                }
              }
            }
          });
        })
      .catch(error => {
        console.error('Failed to get content:', error);
      });
    }
  }
}
Dtails.ProductCard.init();
/* end Product card */

/* Collapsible PDP description */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-content-section").forEach(function (section) {
    const header = section.querySelector(".header3");
    const textContainer = section.querySelector(".product-content-text");
    if (!header || !textContainer) return;
    // Create wrapper for collapsible content
    const contentWrapper = document.createElement("div");
    contentWrapper.className = "collapsible-content";
    Array.from(textContainer.children).forEach(el => {
      if (el !== header) contentWrapper.appendChild(el.cloneNode(true));
    });
    // Clear textContainer, then append header + wrapper
    textContainer.innerHTML = "";
    textContainer.appendChild(header);
    textContainer.appendChild(contentWrapper);
    // Initially collapsed
    contentWrapper.style.maxHeight = "0px";
    contentWrapper.style.overflow = "hidden";
    contentWrapper.style.transition = "max-height 0.3s ease";
    // Toggle
    header.addEventListener("click", function () {
      const isOpen = header.classList.toggle("open");
      contentWrapper.style.maxHeight = isOpen ? contentWrapper.scrollHeight + "px" : "0px";
    });
  });
});
/* end Collapsible PDP description */